import React, { useContext, useMemo } from 'react';
import PricingContext from '../../../context/pricing';
import { EI_PLANS, MC_PLANS } from '../../../constants/pricing/plans';

/**
 * HOC that includes a users package and addon selections as props.
 */
function withSelections(Component) {
  const WithSelections = (props) => {
    const { state } = useContext(PricingContext);

    const eiPackage =
      useMemo(
        () =>
          Object.values(EI_PLANS)
            .flatMap((plan) => Object.values(plan.packages))
            .find((pkg) => pkg.id === state.packages.e),
        [state]
      ) || false;

    const mcPackage =
      useMemo(
        () =>
          Object.values(MC_PLANS)
            .flatMap((plan) => Object.values(plan.packages))
            .find((pkg) => pkg.id === state.packages.mc),
        [state]
      ) || false;

    const hasPaidPlan = () => {
      const eiPaid = !!(eiPackage && eiPackage.rate);
      const mcPaid = !!(mcPackage && mcPackage.rate);
      return !!(eiPaid || mcPaid);
    };

    const easeAdded = state.addons.ease === 30 && eiPackage;
    const ipAdded = state.addons.ip;

    return (
      <Component
        hasPaidPlan={hasPaidPlan()}
        eiPackage={eiPackage}
        mcPackage={mcPackage}
        ipAdded={ipAdded}
        easeAdded={easeAdded}
        {...props}
      />
    );
  };

  WithSelections.displayName = `withSelections(${
    Component.displayName || Component.name || 'Component'
  })`;
  return WithSelections;
}

export default withSelections;
